import { Box, Divider, Typography } from '@mui/material'
import React from 'react'

export const About = () => {
  return (
    <Box sx={{ mt: 8 }}>
        <Typography id="about" variant="h5" fontWeight={600} sx={{mb:2}}>
            🙎🏽‍♂️About
        </Typography>
        <Divider sx={{ mb: 5 }} />
        <Typography variant="h6" gutterBottom color="text.secondary" sx={{fontWeight:"bold"}}>
            <Box sx={{display:"inline", color:"black"}}>👀</Box>Who am I?
        </Typography>
        <Typography paragraph>
            My name is David. I'm an aspiring Computer Scientist 
            who wants to make the world a better place by providing 
            solutions to computer related problems. Currently I am 
            staying at home and using this time to enhance
            programming skills by taking online tutorials.
            I have been working in the computing sphere for the past 3 
            years with some of the experience gained from the projects
            I've built.
        </Typography>
        <Typography paragraph>
            As much as I appreciate my proficiency on the web, I also have 
            some skills in my arsenal namely algorithmic trading, visual basic
            and git. This has helped me to become a vastly skilled personnel whilst
            ensuring an in-depth understanding of programming in general.
        </Typography>
        <Typography paragraph>
            The predominant traits I possess abilities appear to be creativity and
            reliability. Furthermore, I am adept at handling multiple tasks on a daily 
            basis competently and at working well under pressure.
        </Typography>
    </Box>
  )
}
